import { render, staticRenderFns } from "./NewBreadcrumb.vue?vue&type=template&id=531fe504&"
import script from "./NewBreadcrumb.vue?vue&type=script&lang=js&"
export * from "./NewBreadcrumb.vue?vue&type=script&lang=js&"
import style0 from "./NewBreadcrumb.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports